<template>
    <div>
        <v-dialog v-model="showAdd" width="450px" persistent>
            <v-card>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text">{{ place == 0 ? 'New Main Category' : place == 1 ? 'NewSub -Category' : 'New Document' }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <v-row>
                        <v-col>
                            <v-text-field
                                :label="place == 0 ? 'Main Category' : place == 1 ? 'Sub-Category' : 'Document'"
                                v-model="vlu"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-btn @click="createDocument" class="mb-3 mr-3" color="success">Save</v-btn>
                    </v-row>
                </v-container>
            </v-card>
            <confirm-dialogue ref="confirmDialogue" style="z-index: 100;"></confirm-dialogue>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import ConfirmDialogue from './../../ConfirmDialogue.vue';
export default {
    components: {
        ConfirmDialogue
    },
    props: ['place', 'url', 'showAdd', 'parms', 'fld'],
    data: function () {
        return {
            vlu: ''
        }
    },
    methods: {
        // save: function(){
        //     
        //     console.log(this.parms);
        // },

        async createDocument() {
            if (this.place == 2) {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'When the document is created it will be attached to the available drivers',
                    message: 'Are you sure?',
                    okButton: 'Yes',
                    cancelButton: 'No',
                    cancel : 'Cancel'
                });
                // If you throw an error, the method will terminate here unless you surround it wil try/catch
                if (ok) {
                    this.save(1);
                }else{
                    this.save(0);
                }
            } else {
                this.save();
            }
        },

        save: function (all) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            this.parms[this.fld] = this.vlu;
            this.parms.All = all;
            axios
                .post(this.url, this.parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    let rtdata = response.data;
                    switch (this.place) {
                        case 0:
                            rtdata.subcategory = [];
                            break;

                        case 1:
                            rtdata.docs = [];
                            break;
                    }
                    this.$store.state.isLoading = false;
                    this.$emit('push', rtdata);
                    this.$emit('closePush');
                    console.log(this.rtdata);
                    this.$emit('close');
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
    }
}
</script>